import * as Yup from "yup";

export const DEFAULT_STORE_IMAGE =
  "https://everydayheroesrpg.com/wp-content/uploads/2024/06/image-28.png";

export const VOLUNTEER_ROLES = [
  "Staff",
  "Retailer",
  "Ego-minion",
  "Lieutenant",
  "Early-backer",
  "Sidekick-subscriber",
  "Administrator",
  "Game Master",
  "Volunteer",
  "Coordinator",
];

export const storeLocationValidationSchema = Yup.object().shape({
  title: Yup.string().min(3, "Too Short!").trim().required("Store title is required"),
  locationName: Yup.string().trim().required("Location is required"),
  storePhoneNo: Yup.string().trim().required("Phone number is required"),
  storeUrl: Yup.string().url("Invalid URL").trim().required("Store URL is required"),
  content: Yup.string().trim().required("Description is required"),
});
